import { IntegrationContainer } from '../components/IntegrationContainer';
import { guideUrl } from './consts';
import { useBizneoConnection } from './hooks';
import { Step1 } from './components/Step1';
import { AfterConnection } from './components/AfterConnection';

export const Bizneo = () => {
  const { handleSelectedCompanyChange, selectedCompany, triggerConnection, isConnected, isConnectBtnDisabled } =
    useBizneoConnection();

  return (
    <IntegrationContainer setSelectedCompany={handleSelectedCompanyChange} guideUrl={guideUrl || undefined}>
      {selectedCompany && (
        <>
          <Step1 triggerConnection={triggerConnection} isConnectBtnDisabled={isConnectBtnDisabled} />
          {isConnected && <AfterConnection isConnected={isConnected} />}
        </>
      )}
    </IntegrationContainer>
  );
};
